export const generateEmptyGrid = (
  nRow: number,
  nCol: number,
): Array<Array<boolean>> =>
  Array.from<boolean>({ length: nRow }).map(() =>
    Array.from<boolean>({ length: nCol }).fill(false),
  );

export const generateEmptyIndexes = (nRow: number): Array<Array<number>> =>
  [...Array(nRow)].map(_ => []);
